module.exports = __webpack_public_path__ + "img/weddings_14_V.d7b4cfe0.webp";